function init_lickbefore(from_php){
    var main=$(".place.lickbefore");
    
    main.find(".girlBig").each(function(){
        var th=$(this);
        var type=th.attr("data-type");
        var girl_id=from_php[("girl_id_"+type)];
        var suit_id=_girlSuitGeneral.takePvPSuitId(girl_id);
        var suit_have_obj={};
        if(suit_id){
            suit_have_obj["11"]=suit_id;
        }
        var girlObj=new girlSuitView(girl_id,suit_have_obj);
        girlObj.makeView(th.find(".img"));
    });
    
    
    
    
    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px")
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });
    _semaphoreXHR.addForceLocation("lickanim/"+from_php.girl_id_win+"/"+from_php.girl_id_lose+"/first/");
}